import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import l1 from "../assets/Lo1.png";
import l2 from "../assets/Lo2.png";
import l3 from "../assets/Lo3.png";
import l4 from "../assets/Lo4.png";
import l5 from "../assets/Lo5.png";
import l6 from "../assets/Lo6.png";
import l7 from "../assets/Lo7.png";
import l8 from "../assets/Lo8.png";
import l9 from "../assets/Lo9.png";
import lo1 from "../assets/LOO1.png";


import logo from "../assets/logo.png";
import Ar from "../assets/Ar.svg";
import { Link } from "react-router-dom";
import down from "../assets/Down.svg";
import pic from "../assets/Pic.png";
import right from "../assets/Right.svg";
import { toast, ToastContainer } from "react-toastify";
import contact from "../assets/Contact.svg";
import trans from "../assets/Transport.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import dock from "../assets/Dock.svg";
import scrab from "../assets/Scrap.svg";
import work from "../assets/Work.svg";
import order from "../assets/Order.svg";
import riarr from "../assets/Rightarr.svg";
import large from "../assets/Large.png";
import large1 from "../assets/Large1.png";
import large2 from "../assets/Large2.png";
import g1 from "../assets/Group1.png";
import g2 from "../assets/Group2.png";
import g3 from "../assets/Group3.png";
import calendar from "../assets/Calender.png";
import factory from "../assets/Factory.png";
import fly from "../assets/Fly.png";
import w from "../assets/W.png";
import t from "../assets/T.png";
import c from "../assets/C.png";
import star from "../assets/Star.png";
import phone from "../assets/Phone.png";

import o1 from "../assets/O1.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import backdo from "../assets/Do.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";

import trial from "../assets/Trial.png";
import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import ee from "../assets/Email.png";
import mawman from "../assets/Mawman.png";
import "../components/Button.css";



import a1 from "../assets/AA1.png";
import a2 from "../assets/AA2.png";
import a3 from "../assets/AA3.png";
import a4 from "../assets/AA4.png";
import a5 from "../assets/AA5.png";
import a6 from "../assets/AA6.png";
import a7 from "../assets/AA7.png";
import a8 from "../assets/AA8.png";
import a9 from "../assets/AA9.png";



import { Canvas, useFrame } from '@react-three/fiber';
import { Float, useTexture, OrbitControls } from '@react-three/drei';
import { MathUtils } from 'three';






// const fallVariant = {
//   hidden: { y: -400, opacity: 0 },
//   visible: (i) => ({
//     y: [ -400, 0, -30, 0, -10, 0 ],
//     opacity: 1,
//     transition: {
//       delay: i * 0.2,
//       duration: 1.2,
//       ease: "easeOut",
//     },
//   }),
// };

const ExploreProduct = () => {
      const navigate = useNavigate();
      const [activeItem, setActiveItem] = useState("Home");
      const [screenWidth, setScreenWidth] = useState(window.innerWidth);
      const [hoveredItem, setHoveredItem] = useState(null);





  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes arrowSlide {
        0% { transform: translateX(0); }
        50% { transform: translateX(4px); }
        100% { transform: translateX(0); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  const cardRefs = useRef([]);

  useEffect(() => {
    const animate = () => {
      cardRefs.current.forEach((card, index) => {
        if (card) {
          card.style.opacity = "0";
          card.style.transform = "translateY(40px)";
          card.style.transition = "all 0.5s ease-out";

          setTimeout(() => {
            card.style.opacity = "1";
            card.style.transform = "translateY(0)";
            card.style.transition = `all 0.6s ease-out ${index * 0.1}s`;
          }, 300);
        }
      });
    };

    animate();

    const interval = setInterval(() => {
      animate();
    }, 3000);

    return () => clearInterval(interval);
  }, []);



  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownItems = [
    {
      title: "LOGISTICS OPERATIONS",
      items: [
      {
    name: "Gate",
    description: (
      <>
        Helps organizations track and manage
        <br />
        visitors efficiently.
      </>
    ),
    icon: gate,
  },
        // {
        //   icon: dock,
        //   name: "Dock",
        //   description:
        //     "Helps businesses streamline loading, unloading & scheduling.",
        // },
        // {
        //   icon: sign,
        //   name: "Signage",
        //   description:
        //     "Creating, managing & displaying digital content on screens.",
        // },
      ],
    },
    // {
    //   title: "TRACKING SYSTEM",
    //   items: [
    //     {
    //       icon: trans,
    //       name: "Transport",
    //       description:
    //         "Helps users efficiently manage & optimize transportation services.",
    //     },
    //     {
    //       icon: bus,
    //       name: "Vehicle Management",
    //       description:
    //         "Tracks vehicles, optimizes routes, and automates expenses.",
    //     },
    //     {
    //       icon: asset,
    //       name: "Asset",
    //       description:
    //         "Helps businesses track, monitor, and manage assets efficiently.",
    //     },
    //   ],
    // },
    {
      title: "WORKFORCE MANAGEMENT",
      items: [
       {
    name: "MeetQ",
    description: (
      <>
        Book & manage meeting rooms
        <br />
        with real-time tracking.
      </>
    ),
    icon: q,
  },
        // {
        //   icon: tg,
        //   name: "TickGo",
        //   description: "Track tasks, log hours, and update statuses.",
        // },
        // {
        //   icon: n,
        //   name: "Nexus",
        //   description: "Manage attendance, tasks, and productivity.",
        // },
      ],
    },
  ];

  const [position, setPosition] = useState({
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
  });

  useEffect(() => {
    const randomizePosition = () => {
      setPosition({
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
      });
    };

    const interval = setInterval(randomizePosition, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes float {
        0%   { transform: translateY(0); }
        50%  { transform: translateY(-15px); }
        100% { transform: translateY(0); }
      }
    `;
    document.head.appendChild(style);
  }, []);






  const handleClick = (item) => {
    setActiveItem(item);

    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }

    if (item === "Home") {
      navigate("/");
    }

    if (item === "Say Hello") {
      navigate("/contact");
    }

    if (item === "Partner") {
      navigate("/part");
    }
  };
  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };





  const products = [
    {
    name: "Gate",
    description: (
      <>
        Helps organizations track and manage
        <br />
        visitors efficiently.
      </>
    ),
    icon: gate,
  },
    // {
    //   name: "Transport",
    //   description:
    //     "Helps users manage and optimize transportation services efficiently.",
    //   icon: trans,
    // },
   {
    name: "MeetQ",
    description: (
      <>
        Book & manage meeting rooms
        <br />
        with real-time tracking.
      </>
    ),
    icon: q,
  },
    // {
    //   name: "Dock",
    //   description: "Helps businesses streamline loading, unloading & scheduling.",
    //   icon: dock,
    // },
    // {
    //   name: "Vehicle Management",
    //   description:
    //     "Tracks vehicles, optimizes routes, and automates expenses.",
    //   icon: bus,
    // },
    // {
    //   name: "TickGo",
    //   description:
    //     "Track tasks, log hours, and update statuses.",
    //   icon: tg,
    // },
    // {
    //   name: "Signage",
    //   description: "Creating, managing & displaying digital content on screens.",
    //   icon: sign,
    // },
    // {
    //   name: "Asset",
    //   description:
    //     "Helps businesses track, monitor, and manage assets efficiently.",
    //   icon: asset,
    // },
    // {
    //   name: "Nexus",
    //   description:
    //     "Manage attendance, tasks, and productivity.",
    //   icon: n,
    // },
   
  ];






  

 


  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];


  


  const items = [
    {
      label: "Customized solutions",
      image: large, 
    },
    {
      label: "Integrated approach",
      image: large1,
    },
    {
      label: "Concept to deliver",
      image: large2, 
    },
  ];







  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);



  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );
  
    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
  
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);



  
  


  const [inView, setInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("slide-in-section");
      if (!section) return;
  
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
  
      
      if (rect.top < windowHeight && rect.bottom > 0) {
        setInView(true);
      } else {
        setInView(false);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    handleScroll(); 
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const [inVieww, setInVieww] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    const section = document.getElementById("blog-section");
    if (!section) return;

    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      setInVieww(true);
    } else {
      setInVieww(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();
  return () => window.removeEventListener("scroll", handleScroll);
}, []);








    



    const sectionRef = useRef(null); // Ref for the section element
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When the section comes into view
        if (entry.isIntersecting) {
          setIsVisible(true); // Set to true when visible
        } else {
          setIsVisible(false); // Reset visibility when not visible
        }
      },
      {
        threshold: 0.5, // Trigger when 50% of the section is in view
      }
    );

    // Observe the sectionRef element
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Clean up the observer on component unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);



  const [hoveredIndex, setHoveredIndex] = useState(0);
  const [currentImage, setCurrentImage] = useState(items[0]?.image || null);

  
  useEffect(() => {
    const interval = setInterval(() => {
      setHoveredIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % items.length;
        setCurrentImage(items[nextIndex].image);
        return nextIndex;
      });
    }, 1000);

    return () => clearInterval(interval); 
  }, [items]);




  const [size, setSize] = useState(getSize());

  function getSize() {
    const width = window.innerWidth;
    if (width <= 480) return { size: 40, bottom: "8%", right: "6%" }; 
    if (width <= 768) return { size: 45, bottom: "6%", right: "5%" }; 
    return { size: 50, bottom: "5%", right: "4%" }; 
  }

  useEffect(() => {
    const handleResize = () => setSize(getSize());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);




  


const [hoveredCard, setHoveredCard] = useState(null);






  

    
 const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

   const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
  
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
  
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
  
    /* -- redraw every time captchaValue changes ------------------------------------ */
    useEffect(() => {
      if (!data) return; // nothing to paint yet
      const canvas = canvasRef.current;
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
  
      /* ========= clear & background */
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
  
      /* ========= random faint bezier curves (extra distortion) */
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.lineWidth = 1 + Math.random(); // 1-2 px
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.stroke();
      }
  
      /* ========= characters (uneven) */
      ctx.font = "bold 22px Arial";
      ctx.fillStyle = "#0A3A72";
      const chars = data.toString().split("");
  
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 0.8; // ±23°
        const x = 8 + i * 14 + (Math.random() * 4 - 2);
        const y = 22 + (Math.random() * 6 - 3);
  
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
  
      /* ========= dots */
      for (let i = 0; i < 45; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [data]);
  
    /* -- reload button click ------------------------------------------------------- */
    const handleReload = () => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };
  
  const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };




  
    const isMobile = screenWidth <= 768;
    const isTablet = screenWidth > 768 && screenWidth <= 1024;
      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  
  
       const [isMobileOrTablett, setIsMobileOrTablett] = useState(
      typeof window !== "undefined" ? window.innerWidth <= 1024 : false
    );
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobileOrTablett(window.innerWidth <= 1024);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
  
     const [isMobileOrTablet, setIsMobileOrTablet] = useState(
        typeof window !== "undefined" ? window.innerWidth <= 1024 : false
      );
    
      useEffect(() => {
        const handleResize = () => {
          setIsMobileOrTablett(window.innerWidth <= 1024);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);



       const [posts, setPosts] = useState([]);

  /* ───────────────────────────── fetch & parse ───────────────────────────── */
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        // Fetch HTML through a CORS-friendly proxy
        const raw = await fetch(
          `https://api.allorigins.win/raw?url=${encodeURIComponent(
            "https://blog.mawalog.com/"
          )}`
        ).then((r) => r.text());

        const doc = new DOMParser().parseFromString(raw, "text/html");
        const articles = Array.from(doc.querySelectorAll("article")).slice(0, 3);

        const latest = articles.map((art) => {
          /* image ----------------------------------------------------------- */
          const img = art.querySelector("img")?.src || "";

          /* title & link ----------------------------------------------------- */
          const titleEl = art.querySelector("h1, h2, h3, h4, h5, h6");
          const title = titleEl?.textContent.trim() || "Untitled";
          const href = titleEl?.closest("a")?.href || "#";

          /* category --------------------------------------------------------- */
          const category =
            art.querySelector(".cat-links a, .post-category a, .category a")
              ?.textContent.trim() || "General";

          /* posted date ------------------------------------------------------ */
          const timeEl = art.querySelector("time");
          let date = "Unknown date";

          if (timeEl) {
            const attr = timeEl.getAttribute("datetime");
            if (attr) {
              // Parse the machine date → "May 12, 2025"
              const d = new Date(attr);
              if (!isNaN(d))
                date = d.toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                });
            } else if (timeEl.textContent) {
              // Fallback to visible text inside <time>
              date = timeEl.textContent.trim();
            }
          }

          return { img, title, href, category, date };
        });

        setPosts(latest);
      } catch (err) {
        console.error("Blog fetch failed:", err);
        setPosts([]);
      }
    };

    fetchPosts();                               // first load
    const id = setInterval(fetchPosts, 60 * 60 * 1000); // hourly refresh
    return () => clearInterval(id);             // cleanup
  }, []);













//   const logos = [l1, l2, l3, l4, l5, l6, l7, l8, l9];
//  const controls = useAnimation();

//   useEffect(() => {
//     const startAnimation = async () => {
//       // Scroll down smoothly after 0.5s
//       setTimeout(() => {
//         document.getElementById("logoSection")?.scrollIntoView({ behavior: "smooth" });
//       }, 500);

//       // Wait for scroll animation before triggering fall animation
//       await new Promise((res) => setTimeout(res, 1500));
//       controls.start((i) => ({
//         y: [ -500, 0, -30, 0, -10, 0 ],
//         opacity: 1,
//         transition: {
//           delay: i * 0.4,
//           duration: 1.2,
//           ease: "easeOut",
//         },
//       }));
//     };

//     startAnimation();
//   }, []);

//   const fallVariant = {
//     hidden: { y: -500, opacity: 0 },
//     visible: (i) => ({
//       y: [ -500, 0, -30, 0, -10, 0 ],
//       opacity: 1,
//       transition: {
//         delay: i * 0.4,
//         duration: 1.2,
//         ease: "easeOut",
//       },
//     }),
//   };










const cards = [
  {
    title: "MeetQ",
    desc: "Book your meeting rooms easily",
    color: "#ffe5ec",
    textColor: "#cc0f35",
    img: l1,
    ctaIcon: a1,
  },
  {
    title: "Gate Management",
    desc: "Visitor manager for any organization",
    color: "#e4fbe8",
    textColor: "#1d8f3f",
    img: l2,
    ctaIcon:a2,
  },
  {
    title: "Asset Management",
    desc: "Manage your assets without papers",
    color: "#e5f0ff",
    textColor: "#4176fc",
    img: l3,
    ctaIcon: a3,
  },
  {
    title: "Nexus",
    desc: "Manage your employees attendance",
    color: "#e3f2ff",
    textColor: "#2f88e0",
    img: l4,
    ctaIcon: a4,
  },
  {
    title: "TickGo",
    desc: "Create tickets and manage them",
    color: "#efe0ff",
    textColor: "#8e3efc",
    img: l5,
    ctaIcon: a5,
  },
  {
    title: "Signage",
    desc: "Monitor your data with real time dashboard",
    color: "#fff6dc",
    textColor: "#f5b000",
    img: l6,
    ctaIcon: a6,
  },
  {
    title: "Vehicle Management",
    desc: "Manage your vehicles, services and renewals",
    color: "#f4e8ff",
    textColor: "#6b008d",
    img: l7,
    ctaIcon: a7,
  },
  {
    title: "Dock Management",
    desc: "Monitor & allocate docks seamlessly",
    color: "#ffe5e5",
    textColor: "#d53a3a",
    img: l8,
    ctaIcon: a8,
  },
  {
    title: "Transport",
    desc: "Track your vehicles & optimize their routes",
    color: "#e6f1ff",
    textColor: "#4176fc",
    img: l9,
    ctaIcon: a9,
  },
];


const logos = [lo1, l2, l3, l4, l5, l6, l7, l8, l9];

function LogoGroup() {
  const textures = useTexture(logos);
  const group = React.useRef();
  const rotations = useRef([]);

  const yOffset = -0.5;

  useFrame((state, delta) => {
    if (group.current) {
      group.current.rotation.y += delta * 0.1; // rotate the whole group
    }

    // rotate each logo mesh slightly
    rotations.current.forEach((mesh) => {
      if (mesh) {
        mesh.rotation.y += delta * 0.5; // rotate logo itself
      }
    });
  });

  return (
    <group ref={group}>
      {textures.map((tex, i) => {
        const angle = (i / textures.length) * Math.PI * 2;
        const radius = 3;
        const x = Math.cos(angle) * radius;
        const z = Math.sin(angle) * radius;

        return (
          <mesh
            key={i}
            ref={(el) => (rotations.current[i] = el)}
            position={[x, yOffset, z]}
          >
            <planeGeometry args={[0.6, 0.6]} />
            <meshBasicMaterial map={tex} transparent />
          </mesh>
        );
      })}
    </group>
  );
}






  return (
   
    <div>
         <ToastContainer position="top-right" autoClose={3000} />

    

  <>
        <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    top: 0,
    zIndex: 1000,
    display: "flex",
    position: "sticky",
    justifyContent: "space-between",
    alignItems: "center",
    padding: isMobile ? "10px 3%" : "0px 5%",
    backgroundColor: "#fff",
    flexWrap: "wrap",
     borderBottom: "1px solid #ddd", // added border line
  }}
>

<div
  onClick={() => {
    if (window.location.pathname === "/") {
      window.location.reload(); // reload if already on home
    } else {
      window.location.href = "/"; // go to home
    }
  }}
  style={{ cursor: "pointer" }}
>
  <img
    src={logo}
    alt="Logo"
    style={{
      maxWidth: isMobile ? "120px" : "150px",
      height: "auto",
      marginLeft: isMobile ? "-10px" : "-50px",
    }}
  />
</div>

   
           {/* Mobile Hamburger Icon */}
           {isMobile && (
             <button
               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
               style={{ background: "none", border: "none", cursor: "pointer" }}
             >
               <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
               </svg>
             </button>
           )}
   
           {/* Desktop/Tablet Menu */}
           {!isMobile && (
             <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 gap: "8px",
                 flexDirection: "row",
                 width: "auto",
                 backgroundColor: "transparent",
                 padding: "0",
               }}
             >
{["Products", "Partner", "Say Hello"].map((item, index) => (
        <div
          key={index}
          style={{ position: "relative", width: "auto" }}
          onMouseEnter={() => {
            setHoveredItem(item);
            if (item === "Products") setShowDropdown(true);
          }}
          onMouseLeave={() => {
            setHoveredItem(null);
            if (item === "Products") setShowDropdown(false);
          }}
        >
          <div
            onClick={() => handleClick(item)}
            style={{
              fontSize: "clamp(12px, 2vw, 16px)",
              cursor: "pointer",
              fontWeight: "normal",
              backgroundColor:
                activeItem === item || hoveredItem === item
                  ? "#EAF3FF"
                  : "transparent",
              padding: "8px 16px",
              borderRadius: "20px",
              transition: "background-color 0.3s",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "flex-start",
            }}
          >
            {item}
            {item === "Products" && (
              <img
                src={down}
                alt="Down Arrow"
                style={{
                  width: "10px",
                  height: "7px",
                  transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              />
            )}
          </div>

          {item === "Products" && showDropdown && (
            <div
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
              style={{
                position: "fixed",
                top: 30,
                left: "calc(50% - 500px)",
                zIndex: 9999,
                marginTop: "20px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "24px",
                overflow: "hidden",
                width: "980px",
                maxWidth: "90vw",
                padding: "24px",
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "32px",
                boxSizing: "border-box",
              }}
            >
              {dropdownItems.map((section, i) => (
                <div
                  key={i}
                  style={{
                    paddingRight:
                      i < dropdownItems.length - 1 ? "32px" : undefined,
                    borderRight:
                      i < dropdownItems.length - 1
                        ? "1px solid #E0E0E0"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      color: "#666",
                      fontWeight: 600,
                      marginBottom: 16,
                      textTransform: "uppercase",
                      fontSize: 13,
                    }}
                  >
                    {section.title}
                  </div>

                  {section.items.map((product, j) => (
                    <div
                      key={j}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 12,
                        padding: "12px 10px",
                        cursor: "pointer",
                        marginBottom: 12,
                        borderRadius: 8,
                        transition: "background-color 0.3s ease",
                      }}
                      onClick={() => {
                        if (product.name === "Gate") navigate("/gate");
                        else if (product.name === "MeetQ") navigate("/meetq");
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#F0F8FF";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "#004aad";
                        if (arrow) {
                          arrow.style.filter =
                            "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                          arrow.style.transform = "translateX(4px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "inherit";
                        if (arrow) {
                          arrow.style.filter = "none";
                          arrow.style.transform = "translateX(0)";
                        }
                      }}
                    >
                      <img
                        src={product.icon}
                        alt={product.name}
                        style={{ width: 25, height: 25 }}
                      />
                      <div>
                        <div
                          className="product-name"
                          style={{
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            transition: "color 0.3s ease",
                            fontSize: 14,
                          }}
                        >
                          {product.name}
                          <img
                            className="arrow-icon"
                            src={nr}
                            alt="arrow"
                            style={{
                              marginLeft: 4,
                              width: 20,
                              height: 20,
                              transition: "filter 0.3s ease, transform 0.3s ease",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            color: "#666",
                            fontSize: 14,
                            textAlign: "left",
                            lineHeight: 1.4,
                          }}
                        >
                          {product.description}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

   
               <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                 <button
                   onClick={() => (window.location.href = "http://app.mawalog.com/login")}
                   className="login-button"
                   style={{
                     padding: "10px 20px",
                     borderRadius: "20px",
                     border: "1px solid #004aad",
                     backgroundColor: "#fff",
                     color: "#004aad",
                     fontWeight: "bold",
                     cursor: "pointer",
                     fontSize: "16px",
                     transition: "background-color 0.3s",
                   }}
                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
                 >
                   Login
                 </button>
                 <button
                   onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                   className="register-button"
                   style={{
                     padding: "10px 20px",
                     borderRadius: "20px",
                     border: "none",
                     backgroundColor: "#004aad",
                     color: "#fff",
                     fontWeight: "bold",
                     cursor: "pointer",
                     fontSize: "16px",
                     transition: "background-color 0.3s",
                   }}
                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                 >
                   Register
                 </button>
               </div>
             </div>
           )}
         </div>
   
         {/* Mobile Menu */}
         {isMobile && isMobileMenuOpen && (
           <div
             style={{
               position: "fixed",
               top: 0,
               left: 0,
               width: "100%",
               height: "100%",
               backgroundColor: "#fff",
               padding: "20px",
               overflowY: "auto",
               zIndex: 1001,
               boxSizing: "border-box",
               fontFamily: "Epilogue, sans-serif",
             }}
           >
             {/* Header with Logo and Close Button */}
             <div
               style={{
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "center",
                 marginBottom: "20px",
               }}
             >
               <Link to="/">
  <img
    src={logo}
    alt="Logo"
    style={{ width: "120px", height: "auto", cursor: "pointer" }}
  />
</Link>
               <button
                 onClick={() => setIsMobileMenuOpen(false)}
                 style={{ background: "none", border: "none", cursor: "pointer" }}
               >
                 <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                 </svg>
               </button>
             </div>
   
             {/* Navigation Items */}
             {["Products", "Partner", "Say Hello"].map((item, index) => (
               <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                 {item === "Products" ? (
                   <>
                     <div
                       onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                       style={{
                         fontSize: "16px",
                         cursor: "pointer",
                         fontWeight: "600",
                         color: "#004aad",
                         padding: "12px",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "center",
                         borderRadius: "8px",
                         transition: "background-color 0.3s",
                         textAlign: "center",
                       }}
                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                     >
                       Products
                       <img
                         src={down}
                         alt="Arrow"
                         style={{
                           width: "10px",
                           height: "7px",
                           transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                           transition: "transform 0.3s",
                         }}
                       />
                     </div>
                     {mobileProductsOpen && (
                       <div
                         style={{
                           marginTop: "12px",
                           padding: "16px",
                           backgroundColor: "#F9FAFB",
                           borderRadius: "12px",
                           display: "flex",
                           flexDirection: "column",
                           gap: "16px",
                           maxWidth: "100%",
                           overflow: "auto",
                           boxSizing: "border-box",
                           justifyContent: "center",
                           alignItems: "center",
                           textAlign: "center",
                         }}
                       >
                         {dropdownItems.map((section, i) => (
                           <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                             <div
                               style={{
                                 color: "#666",
                                 fontWeight: "600",
                                 textTransform: "uppercase",
                                 fontSize: "12px",
                                 marginBottom: "8px",
                               }}
                             >
                               {section.title}
                             </div>
                             {section.items.map((product, j) => (
                               <div
                                 key={j}
                                 style={{
                                   display: "flex",
                                   flexDirection: "column",
                                   alignItems: "center",
                                   gap: "8px",
                                   padding: "8px",
                                   cursor: "pointer",
                                   borderRadius: "8px",
                                   transition: "background-color 0.3s ease",
                                   maxWidth: "100%",
                                 }}
                                 onClick={() => {
                                   if (product.name === "Gate") navigate("/gate");
                                   else if (product.name === "MeetQ") navigate("/meetq");
                                   setIsMobileMenuOpen(false);
                                 }}
                                 onMouseEnter={(e) => {
                                   e.currentTarget.style.backgroundColor = "#F0F8FF";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "#004aad";
                                 }}
                                 onMouseLeave={(e) => {
                                   e.currentTarget.style.backgroundColor = "transparent";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "inherit";
                                 }}
                               >
                                 <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                 <div style={{ flex: 1, overflow: "hidden" }}>
                                   <div
                                     className="product-name"
                                     style={{
                                       fontWeight: "600",
                                       fontSize: "14px",
                                       transition: "color 0.3s ease",
                                       whiteSpace: "normal",
                                       overflow: "hidden",
                                       textOverflow: "ellipsis",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.name}
                                   </div>
                                   <div
                                     style={{
                                       color: "#666",
                                       fontSize: "12px",
                                       lineHeight: "1.4",
                                       overflowWrap: "break-word",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.description}
                                   </div>
                                 </div>
                               </div>
                             ))}
                           </div>
                         ))}
                         <a
                           href="#"
                           style={{
                             color: "#004aad",
                             fontWeight: "600",
                             fontSize: "14px",
                             textDecoration: "none",
                             display: "inline-flex",
                             alignItems: "center",
                             padding: "8px",
                           }}
                           onClick={() => setIsMobileMenuOpen(false)}
                         >
                           Explore all products
                           <img
                             src={right}
                             alt="arrow"
                             style={{
                               marginLeft: "4px",
                               width: "16px",
                               height: "16px",
                               verticalAlign: "middle",
                             }}
                           />
                         </a>
                       </div>
                     )}
                   </>
                 ) : (
                   <div
                     onClick={() => {
                       handleClick(item);
                       setIsMobileMenuOpen(false);
                     }}
                     style={{
                       fontSize: "16px",
                       cursor: "pointer",
                       fontWeight: "600",
                       color: "#004aad",
                       padding: "12px",
                       borderRadius: "8px",
                       transition: "background-color 0.3s",
                       textAlign: "center",
                     }}
                     onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                     onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                   >
                     {item}
                   </div>
                 )}
               </div>
             ))}
   
             {/* Buttons */}
             <div
               style={{
                 display: "flex",
                 flexDirection: "column",
                 gap: "12px",
                 width: "100%",
                 marginTop: "20px",
               }}
             >
               <button
                 onClick={() => {
                   window.location.href = "http://app.mawalog.com/login";
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "1px solid #004aad",
                   backgroundColor: "#fff",
                   color: "#004aad",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
               >
                 Login
               </button>
               <button
                 onClick={() => {
                   window.open("https://app.mawalog.com/register", "_blank");
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "none",
                   backgroundColor: "#004aad",
                   color: "#fff",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
               >
                 Register
               </button>
             </div>
           </div>
         )}
   
         {/* Media Queries for Tablet Button Size */}
         <style>
           {`
             @media (min-width: 769px) and (max-width: 1024px) {
               .login-button, .register-button {
                 padding: 8px 16px !important;
                 font-size: 14px !important;
               }
             }
           `}
         </style>
       </>


 <div style={{ width: '100%', height: '600px', position: 'relative' }}>
          <Canvas>
            <ambientLight intensity={0.8} />
            <OrbitControls enableZoom={false} enableRotate={false} />
            <LogoGroup />
          </Canvas>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
            }}
          >
            <div style={{ textAlign: 'center', color: '#000' }}>
              <p>We welcome you to join us.</p>
              <h3 style={{ fontSize: '2rem', margin: 0 }}>Start your journey</h3>
            </div>
          </div>
        </div>





<div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
    gap: "20px",
    fontFamily: "Epilogue",
    padding: "40px",
  }}
>
  {cards.map((card, index) => (
    <div
      key={index}
      style={{
        background: card.color,
        borderRadius: "16px",
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "150px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      }}
    >
      {/* Icon */}
      <img
        src={card.img}
        alt={card.title}
        style={{
          width: "42px",
          height: "32px",
          marginBottom: "22px",
        }}
      />

      {/* Title */}
      <h3
        style={{
          fontSize: "17px",
          fontWeight: "700",
          margin: 0,
          marginBottom: "12px",
        }}
      >
        {card.title}
      </h3>

      {/* Description */}
      <p
        style={{
          fontSize: "14px",
          color: "#333",
          margin: 0,
          marginBottom: "auto",
          lineHeight: "1.5",
        }}
      >
        {card.desc}
      </p>

   <a
  href="#"
  style={{
    fontWeight: "600",
    fontSize: "13px",
    color: card.textColor,
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    textDecoration: "none",
    marginTop: "16px",
  }}
>
  TRY NOW
  <img
    src={card.ctaIcon}
    alt="arrow"
    style={{ width: "20px", height: "20px", objectFit: "contain", marginBottom:"2px" }}
  />
</a>
    </div>
  ))}
</div>


<div style={{ maxWidth: "1100px", margin: "0 auto", marginBottom: "60px" }}>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "40px 40px",
      borderRadius: "32px",
      background: "#f8fbff",
      fontFamily: "Epilogue",
      flexWrap: "wrap",
    }}
  >
    {/* Left Content */}
    <div style={{ maxWidth: "540px", flex: "1 1 300px" }}>
      <div
        style={{
          backgroundColor: "#e7f0ff",
          color: "#2f88e0",
          padding: "6px 14px",
          display: "inline-block",
          fontSize: "13px",
          fontWeight: 600,
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        Impacts of Mawalog
      </div>

      <h2
        style={{
          fontSize: "32px",
          lineHeight: "1.3",
          fontWeight: "700",
          marginBottom: "20px",
          color: "#111827",
        }}
      >
        Streamline operations, <br />
        boost efficiency, and <br />
        drive measurable growth
      </h2>

      <p
        style={{
          fontSize: "13px",
          lineHeight: "1.6",
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "0",
        }}
      >
        Mawalog removes bottlenecks and automates tasks to streamline
        operations, <br /> equips teams with real-time data to boost efficiency, and
        delivers clear <br/>  analytics that drive measurable growth.
      </p>
    </div>

    {/* Right Image */}
    <div style={{ flex: "1 1 300px", textAlign: "center" }}>
      <img
        src={mawman}
        alt="Business Efficiency Illustration"
        style={{ maxWidth: "60%", height: "auto", marginTop: "20px" }}
      />
    </div>
  </div>
</div>










        {/* <div
               style={{
                 fontFamily: "Epilogue",
                 lineHeight: "1.4",
                 padding: "clamp(30px, 5vw, 60px)",
                 marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
               }}
             >
               <div
                 style={{
                   maxWidth: "clamp(800px, 90vw, 1200px)",
                   margin: "0 auto",
                 }}
               >
                 <div
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                   }}
                 >
                   <div
                     style={{
                       color: "#181835",
                       fontSize: "clamp(18px, 2.5vw, 22px)",
                       fontWeight: "bold",
                       paddingLeft:
                         screenWidth <= 1440
                           ? "clamp(50px, 10vw, 110px)"
                           : "clamp(100px, 12vw, 170px)",
                       alignSelf: "flex-start",
                     }}
                   >
                     Compliance of our company
                   </div>
                   <div
                     style={{
                       display: "flex",
                       justifyContent: "center",
                       gap: "clamp(10px, 2vw, 15px)",
                       marginTop: "clamp(15px, 2vw, 20px)",
                       flexWrap: "wrap",
                     }}
                   >
                     {complianceData.slice(0, 3).map((item, index) => (
                       <div
                         key={index}
                         style={{
                           display: "flex",
                           alignItems: "center",
                           backgroundColor: "#F4F7FF",
                           width: "clamp(200px, 30vw, 270px)",
                           height: "clamp(35px, 5vw, 40px)",
                           padding: "clamp(4px, 1vw, 5px)",
                           borderRadius: "30px",
                           justifyContent: "space-between",
                           cursor: "pointer",
                           transition: "background-color 0.3s, transform 0.3s ease",
                           marginBottom:
                             screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                         }}
                         onMouseEnter={(e) => {
                           e.currentTarget.style.backgroundColor = "#EDF4FF";
                           e.currentTarget.style.transform = "scale(1.03)";
                         }}
                         onMouseLeave={(e) => {
                           e.currentTarget.style.backgroundColor = "#F4F7FF";
                           e.currentTarget.style.transform = "scale(1)";
                         }}
                       >
                         <div style={{ display: "flex", alignItems: "center" }}>
                           <div
                             style={{
                               borderRadius: "50%",
                               padding: "clamp(8px, 1.5vw, 10px)",
                               marginRight: "clamp(8px, 1.5vw, 12px)",
                             }}
                           >
                             <img
                               src={item.icon}
                               alt={item.title}
                               style={{
                                 width: "clamp(30px, 4vw, 40px)",
                                 height: "clamp(30px, 4vw, 40px)",
                               }}
                             />
                           </div>
                           <span
                             style={{
                               color: "#181835",
                               fontSize: "clamp(10px, 1.5vw, 12px)",
                               marginRight: "-10px",
                             }}
                           >
                             {item.title}
                           </span>
                         </div>
                         <img
                           src={riarr}
                           alt="Arrow"
                           style={{
                             width: "clamp(14px, 2vw, 18px)",
                             height: "clamp(14px, 2vw, 18px)",
                           }}
                         />
                       </div>
                     ))}
                   </div>
                 </div>
                 <div
                   style={{
                     display: "flex",
                     justifyContent: "center",
                     gap: "clamp(10px, 2vw, 15px)",
                     marginTop: "clamp(15px, 2vw, 20px)",
                     flexWrap: "wrap",
                     marginRight:
                       screenWidth <= 1024
                         ? "clamp(5px, 2vw, 10px)"
                         : "clamp(100px, 20vw, 290px)",
                   }}
                 >
                   {complianceData.slice(3, 5).map((item, index) => (
                     <div
                       key={index}
                       style={{
                         display: "flex",
                         alignItems: "center",
                         backgroundColor: "#F4F7FF",
                         width: "clamp(200px, 30vw, 270px)",
                         height: "clamp(35px, 5vw, 40px)",
                         padding: "clamp(4px, 1vw, 5px)",
                         borderRadius: "30px",
                         justifyContent: "space-between",
                         cursor: "pointer",
                         transition: "background-color 0.3s, transform 0.3s ease",
                         marginBottom:
                           screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                       }}
                       onMouseEnter={(e) => {
                         e.currentTarget.style.backgroundColor = "#EDF4FF";
                         e.currentTarget.style.transform = "scale(1.03)";
                       }}
                       onMouseLeave={(e) => {
                         e.currentTarget.style.backgroundColor = "#F4F7FF";
                         e.currentTarget.style.transform = "scale(1)";
                       }}
                     >
                       <div style={{ display: "flex", alignItems: "center" }}>
                         <div
                           style={{
                             borderRadius: "50%",
                             padding: "clamp(8px, 1.5vw, 10px)",
                             marginRight: "clamp(8px, 1.5vw, 12px)",
                           }}
                         >
                           <img
                             src={item.icon}
                             alt={item.title}
                             style={{
                               width: "clamp(30px, 4vw, 40px)",
                               height: "clamp(30px, 4vw, 40px)",
                             }}
                           />
                         </div>
                         <span
                           style={{
                             color: "#181835",
                             fontSize: "clamp(10px, 1.5vw, 12px)",
                             marginRight: "-10px",
                           }}
                         >
                           {item.title}
                         </span>
                       </div>
                       <img
                         src={riarr}
                         alt="Arrow"
                         style={{
                           width: "clamp(14px, 2vw, 18px)",
                           height: "clamp(14px, 2vw, 18px)",
                         }}
                       />
                     </div>
                   ))}
                 </div>
               </div>
             </div> */}
       
             <div
               style={{
                 fontFamily: "Epilogue",
                 lineHeight: "1.4",
                 display: "flex",
                 alignItems: "center",
                 marginTop: "-20px",
                 justifyContent: "center",
                 backgroundColor: "#004BA8",
                 padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
                 color: "#fff",
               }}
               className="newsletter-section"
             >
               <div
                 style={{
                   marginRight: "clamp(20px, 3vw, 40px)",
                   marginBottom: "clamp(16px, 2vw, 20px)",
                 }}
               >
                 <img
                   src={news}
                   alt="Newsletter"
                   style={{
                     width: "clamp(150px, 20vw, 200px)",
                     height: "clamp(120px, 15vw, 170px)",
                     animation: "floatImage 3s ease-in-out infinite",
                   }}
                 />
               </div>
       
               <style>
                 {`
             @keyframes floatImage {
               0% { transform: translateY(0); }
               50% { transform: translateY(-10px); }
               100% { transform: translateY(0); }
             }
       
             @media (max-width: 480px) {
               .newsletter-section {
                 flex-direction: column;
                 text-align: center;
                 padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
               }
               .newsletter-section > div:first-child {
                 margin-right: 0;
                 margin-bottom: clamp(16px, 2vw, 20px);
               }
               .newsletter-section h2,
               .newsletter-section p,
               .newsletter-section > div > div,
               .newsletter-section > div > div:last-child {
                 margin-left: 0;
               }
               .newsletter-section .newsletter-input {
                 min-width: clamp(200px, 80vw, 260px);
               }
               .newsletter-section button {
               
                 display: block;
               }
             }
           `}
               </style>
       
               <div className="newsletter-content">
                        {/* Title and Paragraph */}
                        <>
                          <style>
                            {`
                    .newsletter-text {
                      font-family: Epilogue;
                      line-height: 1.4;
                      font-size: 22px;
                      margin-bottom: 10px;
                      margin-left: 60px;
                    }
              
                    @media (max-width: 1024px) {
                      .newsletter-text {
                        font-size: 20px;
                        margin-left: 50px;
                      }
                    }
              
                    @media (max-width: 768px) {
                      .newsletter-text {
                        font-size: 18px;
                        margin-left: 40px;
                      }
                    }
              
                    @media (max-width: 480px) {
                      .newsletter-text {
                        font-size: 16px;
                        margin-left: 30px;
                      }
                    }
                  `}
                          </style>
              
                          <div className="newsletter-text">Subscribe to our Newsletter!</div>
                        </>
              
                        <>
                          <style>
                            {`
                    .newsletter-description {
                      font-size: 14px;
                      margin-bottom: 20px;
                      text-align: start;
                      margin-left: 60px;
                      max-width: 100%;
                      box-sizing: border-box;
                    }
              
                    @media (max-width: 1024px) {
                      .newsletter-description {
                        font-size: 13px;
                        margin-left: 50px;
                      }
                    }
              
                    @media (max-width: 768px) {
                      .newsletter-description {
                        font-size: 12.5px;
                        margin-left: 40px;
                      }
                    }
              
                    @media (max-width: 480px) {
                      .newsletter-description {
                        font-size: 9px; /* reduced more for small screens */
                        text-align: center;
                    
                      }
                    }
                  `}
                          </style>
              
                          <div className="newsletter-description">
                            Stay updated with our latest news, offers, and insights! Subscribe{" "}
                            <br />
                            for exclusive updates delivered straight to your inbox.
                          </div>
                        </>
              
                        
                      <>
                <style>
                  {`
                    .input-wrapper {
                      display: flex;
                      align-items: center;
                      position: relative;
                      width: 100%;
                      max-width: 400px;
                      margin: 0 auto 10px auto; /* center aligned */
                      flex-wrap: nowrap;
                    }
              
                    .email-input {
                      padding: 14px 16px 14px 48px;
                      border-radius: 10px;
                      border: 1px solid #9FCAFF;
                      outline: none;
                      background-color: #00377B;
                      color: #fff;
                      flex: 1;
                      width: 100%;
                      box-sizing: border-box;
                      font-size: 16px;
                    }
              
                    .email-icon {
                      position: absolute;
                      left: 16px;
                      width: 20px;
                      height: 20px;
                    }
              
                    /* Optional: Keep consistent appearance on all devices */
                    @media (max-width: 480px) {
                      .email-input {
                        padding: 12px 12px 12px 44px;
                        font-size: 14px;
                      }
                    }
                  `}
                </style>
              
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <div className="input-wrapper">
                    <img src={mail} alt="Email Icon" className="email-icon" />
                    <input
                      type="email"
                      value={email}
                      placeholder="sample@gmail.com"
                      className="email-input"
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </>
              
              
                       
                        <>
                          <style>{`
                      .captcha-container {
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        margin: 10px auto !important;
                        border-radius: 20px !important;    
                        gap: 8px !important;
                        flex-wrap: wrap !important;
                      }
                    .captcha-box {
                width: 60px !important;
                height: 40px !important;
                border-radius: 8px !important;
                background-color: #fff !important;
                box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                overflow: hidden !important; /* Add this to clip canvas overflow */
              }
              
              #captchaCanvas {
                border-radius: 20px !important;
              }
                      .captcha-input {
                        padding:10px 1px!important;
                        border-radius:8px!important;
                        border:1px solid #ccc!important;
                        outline:none!important;
                        min-width:120px!important;
                        background:#00377B!important;
                        color:#fff!important;
                      }
                      .subscribe-button {
                        padding:14px 30px!important;
                        border-radius:12px!important;
                        border:none!important;
                        background:#fff!important;
                        color:#0A3A72!important;
                        font-weight:bold!important;
                        cursor:pointer!important;
                        margin-bottom:0!important;
                      }
                      @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
                      @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
                      @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
                    `}</style>
              
                          <div className="captcha-container">
                            <div className="captcha-box">
                              <canvas
                                ref={canvasRef}
                                id="captchaCanvas"
                                width={60}
                                height={40}
                              />
                            </div>
              
                            <button
                              onClick={handleReload}
                              style={{
                                background: "#2563EB",
                                color: "#fff",
                                border: "none",
                                padding: "8px",
                                borderRadius: "8px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {/* Your reload SVG icon here */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="23 4 23 10 17 10"></polyline>
                                <polyline points="1 20 1 14 7 14"></polyline>
                                <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                              </svg>
                            </button>
              
                            <input
                              type="text"
                              placeholder="Enter captcha"
                              value={userCaptcha}
                              onChange={(e) => setUserCaptcha(e.target.value)}
                              className="captcha-input"
                            />
              
                            <button className="subscribe-button" onClick={handleSubscribe}>
                              Subscribe
                            </button>
                          </div>
                        </>
              
                        {/* Note */}
                        <div
                          style={{
                            fontSize: "12px",
                            marginTop: "10px",
                            color: "#fff",
                            marginLeft:
                              window.innerWidth <= 480
                                ? "20px"
                                : window.innerWidth <= 768
                                ? "40px"
                                : window.innerWidth <= 1024
                                ? "50px"
                                : "60px",
                          }}
                        >
                          *Unsubscribe anytime. We don’t send any spam
                        </div>
                      </div>
             </div>
       
            <div
         style={{
           fontFamily: "Epilogue",
           lineHeight: "1.4",
           display: "flex",
           justifyContent: "space-between",
           padding: isMobile ? "20px 10px" : "40px",
           backgroundColor: "#fff",
           flexWrap: "wrap",
           maxWidth: "1200px",
           margin: "0 auto",
           boxSizing: "border-box",
         }}
       >
         <div
           style={{
             maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
             marginBottom: "40px",
           }}
         >
           <img
             src={logo}
             alt="Mawalog"
             style={{
               width: isMobile ? "150px" : "180px",
               height: "auto",
               display: "flex",
               justifyContent: "start",
             }}
           />
           <p
             style={{
               color: "#555",
               fontSize: isMobile ? "12px" : "14px",
               lineHeight: "1.6",
               textAlign: "start",
               marginBottom: isMobile ? "20px" : "100px",
             }}
           >
             At Mawalog, we believe in simplifying the complexities of supply chain
             management by offering an integrated platform that combines manufacturing,
             logistics, and warehouse solutions partner with optimized logistics and a
             global network.
           </p>
           <div
             style={{
               display: "flex",
               gap: "12px",
               marginTop: isMobile ? "0" : "-80px",
             }}
           >
             {[insta, face, youtube, link].map((icon, index) => (
               <img
                 key={index}
                 src={icon}
                 alt={`icon-${index}`}
                 style={{
                   width: isMobile ? "20px" : "24px",
                   height: isMobile ? "20px" : "24px",
                   cursor: "pointer",
                   transition: "transform 0.3s ease",
                   transformOrigin: "center",
                 }}
                 onMouseEnter={(e) =>
                   (e.currentTarget.style.transform = "scale(1.4)")
                 }
                 onMouseLeave={(e) =>
                   (e.currentTarget.style.transform = "scale(1)")
                 }
                 onClick={() => {
                   if (icon === face)
                     window.open("https://www.facebook.com/mawalogone/", "_blank");
                   if (icon === youtube)
                     window.open("https://www.youtube.com/@mawalogone", "_blank");
                   if (icon === insta)
                     window.open("https://www.instagram.com/mawalogone/", "_blank");
                   if (icon === link)
                     window.open(
                       "https://www.linkedin.com/company/mawalogone/",
                       "_blank"
                     );
                 }}
               />
             ))}
           </div>
         </div>
       
         <div
         style={{
           display: "flex",
           gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
           flexWrap: "wrap",
           justifyContent: isMobile ? "flex-start" : "space-between",
         }}
       >
         <div>
           <h4
             style={{
               fontSize: isMobile ? "12px" : "14px",
               fontWeight: "bold",
             }}
           >
             Know More
           </h4>
           {["Opportunities", "Articles", "Our Story", "Help Center"].map(
             (item, index) => (
               <p
                 key={index}
                 style={{
                   margin: "8px 0",
                   color: "#555",
                   cursor: "pointer",
                   textAlign: "start",
                   fontSize: isMobile ? "12px" : "14px",
                   transition: "color 0.3s ease",
                   paddingBottom: "2px",
                 }}
                 onClick={() => {
                   if (item === "Our Story") navigate("/about");
                 }}
                 onMouseEnter={(e) => {
                   e.currentTarget.style.color = "#3B82F6";
                 }}
                 onMouseLeave={(e) => {
                   e.currentTarget.style.color = "#555";
                 }}
               >
                 {item}
               </p>
             )
           )}
         </div>
       
        <div>
         <h4
           style={{
             fontSize: isMobile ? "12px" : "14px",
             fontWeight: "bold",
             marginRight: isMobile ? "0" : "20px",
           }}
         >
           Legal &amp; Policies
         </h4>
       
         {[
           "Terms and Conditions",
           "Privacy Policy",
           "Cookie Policy",
           "Copyright Policy",
         ].map((item, index) => (
           <p
             key={index}
             style={{
               margin: "8px 0",
               color: "#555",
               cursor: "pointer",
               textAlign: "start",
               fontSize: isMobile ? "12px" : "14px",
               transition: "color 0.3s ease",
               paddingBottom: "2px",
             }}
             onClick={() => navigate("/terms")}       
             onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
             onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
           >
             {item}
           </p>
         ))}
       </div>
       
       </div>
       
       
         <div style={{ marginBottom: "40px" }}>
           <h4
             style={{
               fontSize: isMobile ? "12px" : "14px",
               fontWeight: "bold",
               marginRight: isMobile ? "0" : "180px",
             }}
           >
             Contact us
           </h4>
           <a
             href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
             target="_blank"
             rel="noopener noreferrer"
             style={{
               color: "#004BA8",
               cursor: "pointer",
               fontSize: isMobile ? "12px" : "14px",
               textAlign: "start",
               textDecoration: "none",
               display: "flex",
               alignItems: "center",
             }}
           >
             <img
               src={ee}
               alt="Email"
               style={{
                 width: isMobile ? "12px" : "14px",
                 height: isMobile ? "12px" : "14px",
                 marginRight: "8px",
               }}
             />
             info@mawalog.com
           </a>
           {[
             { phone: "603-27700-311", country: "Malaysia" },
             { phone: "+971-50-1234567", country: "UAE" },
             { phone: "+44 7911 123456", country: "UK" },
             { phone: "+91-44-4856-3345", country: "India" },
           ].map((contact, index) => (
             <p
               key={index}
               style={{
                 fontSize: isMobile ? "12px" : "14px",
                 textAlign: "start",
               }}
             >
               <img
                 src={phone}
                 alt="Phone"
                 style={{
                   width: isMobile ? "12px" : "14px",
                   height: isMobile ? "12px" : "14px",
                   marginRight: "8px",
                 }}
               />
               <a
                 href={`tel:${contact.phone}`}
                 style={{
                   color: "#004BA8",
                   cursor: "pointer",
                   textDecoration: "none",
                 }}
               >
                 {contact.phone}
               </a>{" "}
               (<span style={{ color: "#000" }}>{contact.country}</span>)
             </p>
           ))}
         </div>
       
         <div
           className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
           style={{ marginBottom: "40px", position: "relative" }}
         >
           <div style={{ position: "relative", display: "inline-block" }}>
             <a
               href="https://app.mawalog.com/register"
               target="_blank"
               rel="noopener noreferrer"
             >
               <img
                 src={trial}
                 alt="Illustration"
                 style={{
                   width: isMobile ? "180px" : isTablet ? "200px" : "210px",
                   height: "auto",
                   display: "block",
                   cursor: "pointer",
                 }}
               />
             </a>
             <div
               style={{
                 position: "absolute",
                 top: 0,
                 left: 0,
                 width: "100%",
                 height: "100%",
                 overflow: "hidden",
                 pointerEvents: "none",
                 zIndex: 2,
               }}
             >
               <div
                 style={{
                   position: "absolute",
                   top: 0,
                   left: "-100%",
                   width: "100%",
                   height: "100%",
                   background:
                     "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
                   animation: "shine 3s ease-in-out infinite",
                 }}
               ></div>
             </div>
           </div>
           <style>
             {`
               @keyframes shine {
                 0% { left: -100%; }
                 100% { left: 100%; }
               }
             `}
           </style>
         </div>
       </div>
       
       
             <div
               style={{
                 fontFamily: "Epilogue",
                 lineHeight: "1.4",
                 textAlign: "center",
                 padding: "clamp(16px, 2vw, 20px) 0",
                 borderTop: "1px solid #ddd",
                 fontSize: "clamp(12px, 1.5vw, 14px)",
                 color: "#333",
               }}
             >
               Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
             </div>
    </div>
  );
};

export default ExploreProduct;
